'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n\n  font-family: \'GriddleIcon\';\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 0;\n  -webkit-font-smoothing: antialiased;\n  display: inline-block;\n  text-decoration: inherit;\n'], ['\n\n  font-family: \'GriddleIcon\';\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 0;\n  -webkit-font-smoothing: antialiased;\n  display: inline-block;\n  text-decoration: inherit;\n']);

var _styledComponents = require('styled-components');

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var fontFamily = (0, _styledComponents.css)(_templateObject);

exports.default = fontFamily;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-data-grid/Font.js
// module id = 1285
// module chunks = 4